import api from '@/api';

const SET_INSTRUCTOR = 'SET_INSTRUCTOR';

export default {
  namespaced: true,

  state: () => ({
    instructor: null,
  }),

  getters: {
    getInstructor: ({ instructor }) => instructor,
  },

  actions: {
    /**
     * @param commit
     * @param {string} instructorId
     * @returns {Promise<Object>}
     */
    async fetchInstructor({ commit }, instructorId) {
      const instructor = await api.getInstructor(instructorId);
      commit(SET_INSTRUCTOR, instructor);
      return instructor;
    },
  },

  mutations: {
    [SET_INSTRUCTOR](state, payload) {
      state.instructor = payload;
    },
  },
};
